import { motion } from "framer-motion";
import { PROCESS } from "../data";

export const Process = () => {
  return (
    <section id="werkwijze" data-testid="process-section" className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-40">
      <div className="grid md:grid-cols-12 gap-8 md:gap-12">
        <div className="md:col-span-4">
          <div className="md:sticky md:top-32">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-12 bg-[var(--blue)]" />
              <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-black/50">Werkwijze</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-medium tracking-tight leading-[1.02]">
              Van eerste schets tot sleuteloverdracht.
            </h2>
            <p className="mt-6 text-lg text-black/70 leading-relaxed max-w-sm">
              Een heldere aanpak in vier stappen. Transparant, planmatig en met korte lijnen.
            </p>
          </div>
        </div>

        <div className="md:col-span-8">
          <div className="border-t border-black/10">
            {PROCESS.map((step, i) => (
              <motion.div
                key={step.n}
                data-testid={`process-step-${step.n}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
                className="group grid grid-cols-[auto_1fr] gap-6 md:gap-12 items-start py-10 md:py-14 border-b border-black/10 hover:pl-4 transition-[padding] duration-500"
              >
                <span className="font-display text-5xl md:text-7xl font-semibold tracking-tighter text-black/15 group-hover:text-[var(--orange)] transition-colors duration-500">
                  {step.n}
                </span>
                <div className="pt-1 md:pt-3">
                  <h3 className="font-display text-2xl md:text-3xl font-medium tracking-tight">{step.title}</h3>
                  <p className="mt-3 text-black/60 leading-relaxed max-w-lg">{step.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
